// extracted by mini-css-extract-plugin
module.exports = {"img":"_1D1PHv","item":"_2YyiIp"};